module.exports = __webpack_public_path__ + "img/10.06f7a768.jpg";